<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="1200">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col v-for="attr in attributes" :key="attr.id" :cols="attr.size">
        <template v-if="attr.type == 'STRING'">
          <v-text-field
            v-model="attr.value"
            :label="attr.name"
            :required="attr.required"
            hide-details
            :outlined="outlinedInputs"
        /></template>
        <template v-if="attr.type == 'TEXT'">
          <v-textarea
            v-model="attr.value"
            :label="attr.name"
            :required="attr.required"
            hide-details
            :outlined="outlinedInputs"
        /></template>
        <template v-if="attr.type == 'DATE'">
          <date-picker
            v-model="attr.value"
            :label="attr.name"
            :required="attr.required"
            hide-details
            :outlined="outlinedInputs"
          />
        </template>
        <template v-if="attr.type == 'TIME'">
          <v-text-field
            v-model="attr.value"
            :label="attr.name"
            :required="attr.required"
            hide-details
            :outlined="outlinedInputs"
            type="time"
        /></template>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col>
        <code>{{ attributes }}</code>
        <code>{{ value }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import { removeGQLTypename } from "../../../../helpers";
import BasicDialog from "../BasicDialog.vue";
import DatePicker from "../DatePicker.vue";
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    customDataType: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog, DatePicker },

  name: "custom-data-record-edit-dialog",

  data() {
    return {
      debug: false,
      id: this.value && this.value.id ? this.value.id : null,
      attributes: this.value ? this.getAttributes() : [],
    };
  },

  computed: {
    editorTitle() {
      return this.value && this.value.id ? "Edit Record" : "Add Record";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.attributes.every((a) => {
        return !a.required || (a.value && a.value.length > 0);
      });
    },
  },

  watch: {
    customDataType() {
      this.attributes = this.getAttributes();
    },
    value() {
      this.id = this.value && this.value.id ? this.value.id : null;
      this.attributes = this.getAttributes();
    },
  },
  methods: {
    onSave() {
      this.$emit("input", {
        id: this.id ? this.id : undefined,
        attributes: this.attributes.map((a) => {
          return {
            customDataTypeAttributeId: a.id,
            content: a.value,
          };
        }),
      });
    },
    getAttributes() {
      return this.customDataType
        ? this.customDataType.attributes.edges
            .map(removeGQLTypename)
            .map((a) => {
              return {
                ...a,
                size: 6,
                value: this.value ? this.value[a.id] : null,
              };
            })
        : [];
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/custom-data-types/CustomDataRecordEditDialog.vue